import React, { RefObject } from "react"

export const MainRefContext =
  React.createContext<RefObject<HTMLElement | null> | null>(null)

export const useMainRef = (args?: {
  fallback: RefObject<HTMLElement | null> | null
}): React.RefObject<HTMLElement | null> => {
  const { fallback = null } = args || {}
  const context = React.useContext(MainRefContext)

  if (!context && !fallback) {
    throw new Error(
      "useMainRef must be used within a MainRefProvider or provide a fallback"
    )
  }
  return (context || fallback) as React.RefObject<HTMLElement | null>
}
